// src/Components/CursorClickEffect.jsx
import { useEffect, useState } from "react";

const CursorClickEffect = () => {
  const [clicks, setClicks] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      const newClick = {
        x: e.clientX,
        y: e.clientY,
        id: Date.now(),
      };
      setClicks((prev) => [...prev, newClick]);

      setTimeout(() => {
        setClicks((prev) => prev.filter((c) => c.id !== newClick.id));
      }, 600); // remove after animation
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  return (
    <>
      {clicks.map((click) => (
        <span
          key={click.id}
          className="fixed w-8 h-8 border-2 border-indigo-400 rounded-full pointer-events-none animate-clickEffect"
          style={{
            top: click.y - 16,
            left: click.x - 16,
            zIndex: 9999,
          }}
        ></span>
      ))}
    </>
  );
};

export default CursorClickEffect;
